import { Modal, Typography } from 'antd';
import React from 'react';

import { useDeleteFile } from '@/api';
import { showMessage } from '@/shared/utils';

interface DeleteFileModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  filePath: string | undefined;
}

export function DeleteFileModal({ isOpen, onCancel, onSuccess, filePath }: DeleteFileModalProps) {
  const deleteFileMutation = useDeleteFile();

  const handleOk = () => {
    if (!filePath) {
      return;
    }
    deleteFileMutation.mutate(filePath, {
      onSuccess: () => {
        showMessage('success', 'Datei erfolgreich gelöscht');
        onSuccess();
      },
      onError: (error) => {
        showMessage('error', error.message);
      },
    });
  };

  return (
    <Modal title='Datei löschen' open={isOpen} onOk={handleOk} onCancel={onCancel}>
      <Typography.Text>
        Möchten Sie die Datei "{filePath?.replace(/\/+$/, '').split('/').pop()}" wirklich löschen?
      </Typography.Text>
    </Modal>
  );
}
